<template>
  <section class="section">
    <div class="container mt-6-desktop">
      <div class="columns">
        <div class="column has-text-centered">
          <img
            :src="visualize"
            alt="visualization_tools"
            title="herramientas de visualizacion"
          />
          <h2 class="title">Visualiza y analiza tus datos.</h2>
          <p class="subtitle">
            Puedes acceder a tu información consolidada y actualizada desde
            cualquier herramienta de visualización, tales como:
          </p>
        </div>
      </div>
    </div>

    <div class="container py-5">
      <div class="columns is-centered">
        <div
          v-for="item in data"
          :key="item.id"
          class="column is-12-mobile is-3-tablet"
        >
          <div class="tile is-ancestor">
            <div class="tile is-parent has-text-centered">
              <article
                class="tile is-child notification is-primary is-light"
                :class="[$style.tilePadding, $style.tileStyles]"
              >
                <img :class="$style.tileImage" :src="item.logo" alt="logo" />
                <p class="subtitle">{{ item.name }}</p>
              </article>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { visualize } from "@/assets/images";

export default {
  name: "Visualizers",
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data: () => {
    return { visualize: visualize };
  },
};
</script>

<style lang="scss" module>
@import "../styles/home.scss";

.showSeparator {
  border-bottom: 1px solid #d0d0d0;
}
</style>
